import { render, staticRenderFns } from "./BrokerCallsList.vue?vue&type=template&id=37f5bf57&scoped=true"
import script from "./BrokerCallsList.vue?vue&type=script&lang=js"
export * from "./BrokerCallsList.vue?vue&type=script&lang=js"
import style0 from "./BrokerCallsList.vue?vue&type=style&index=0&id=37f5bf57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f5bf57",
  null
  
)

export default component.exports